import { SupplierDirectDeliveryMessageUI } from "./SupplierDirectDeliveryMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { getSupplierDirectOption } from "../../utils/product/isSupplierDirect";

export function SupplierDirectDeliveryMessage({
  product,
}: Pick<StandardProps, "product">) {
  const {
    variant: { availability },
  } = useVariant(product);

  const isAvailableToOrder = availability?.availableToOrder ?? false;

  const comingSoon = availability?.futureAvailability ?? false;

  const supplierDeliveryOption = getSupplierDirectOption(product);

  const shouldDisplay =
    supplierDeliveryOption !== null && (isAvailableToOrder || comingSoon);

  return shouldDisplay ? (
    <SupplierDirectDeliveryMessageUI
      deliveryCost={supplierDeliveryOption?.price?.value}
    />
  ) : null;
}
